/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ displayName: NonNullable<unknown>, product: NonNullable<unknown> }} Existing_Subscription_Conflict_HeadingInputs */

const en_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`We found an existing ${i?.displayName} purchase associated with your Brave account`);
	return /** @type {LocalizedString} */ (`We found an existing ${i?.displayName} subscription associated with your Brave account`)
	
};

const id_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Kami menemukan pembelian ${i?.displayName} yang sudah terkait dengan account Brave Anda`);
	return /** @type {LocalizedString} */ (`Kami menemukan langganan ${i?.displayName} yang sudah ada dan terkait ke akun Brave Anda`)
	
};

const ms_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Kami menemui pembelian ${i?.displayName} sedia ada yang dikaitkan dengan akaun Brave anda`);
	return /** @type {LocalizedString} */ (`Kami menemui langganan ${i?.displayName} sedia ada yang dikaitkan dengan akaun Brave anda`)
	
};

const ca_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Hem trobat una compra existent de ${i?.displayName} associada al teu compte de Brave`);
	return /** @type {LocalizedString} */ (`Hem trobat una subscripció ${i?.displayName} vigent associada al teu compte de Brave`)
	
};

const cs_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Našli jsme existující nákup ${i?.displayName} spojený s vaším účtem Brave`);
	return /** @type {LocalizedString} */ (`Našli jsme stávající předplatné ${i?.displayName} propojené s vaším účtem Brave.`)
	
};

const da_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Vi fandt et eksisterende ${i?.displayName}-køb tilknyttet din Brave-konto`);
	return /** @type {LocalizedString} */ (`Vi har fundet et eksisterende ${i?.displayName}-abonnement, der er forbundet til din Brave-konto`)
	
};

const de_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Wir haben einen bestehenden ${i?.displayName}-Kauf gefunden, der mit Ihrem Brave-Konto verknüpft ist`);
	return /** @type {LocalizedString} */ (`Wir haben ein bestehendes ${i?.displayName}-Abonnement gefunden, das mit Ihrem Brave-Konto in Verbindung steht`)
	
};

const et_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Leidsime sinu Brave'i kontoga seotud olemasoleva ${i?.displayName} ostu`);
	return /** @type {LocalizedString} */ (`Leidsime teie Brave'i kontoga seotud teenuse ${i?.displayName} tellimuse`)
	
};

const es_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Encontramos una compra existente de ${i?.displayName} asociada a tu cuenta de Brave`);
	return /** @type {LocalizedString} */ (`Encontramos una suscripción de ${i?.displayName} asociada con tu cuenta de Brave`)
	
};

const fr_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Nous avons trouvé un achat ${i?.displayName} existant associé à votre compte Brave`);
	return /** @type {LocalizedString} */ (`Nous avons trouvé un abonnement ${i?.displayName} existant associé à votre compte Brave.`)
	
};

const hr_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Pronašli smo postojeću ${i?.displayName} kupnju povezanu s vašim Brave računom`);
	return /** @type {LocalizedString} */ (`Pronašli smo postojeću pretplatu ${i?.displayName} povezanu s vašim računom Brave`)
	
};

const it_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Abbiamo trovato un acquisto ${i?.displayName} esistente associato al tuo account Brave`);
	return /** @type {LocalizedString} */ (`Abbiamo trovato un abbonamento a ${i?.displayName} già esistente associato al tuo account Brave`)
	
};

const lv_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Mēs atradām esošu ${i?.displayName} pirkumu, kas saistīts ar jūsu Brave kontu`);
	return /** @type {LocalizedString} */ (`Mēs atradām jau esošu ${i?.displayName} abonementu, kas piesaistīts jūsu Brave kontam`)
	
};

const lt_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Radome esamą ${i?.displayName} pirkinį, susietą su jūsų Brave paskyra`);
	return /** @type {LocalizedString} */ (`Radome esamą ${i?.displayName} prenumeratą, susietą su jūsų „Brave“ paskyra`)
	
};

const hu_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Találtunk egy meglévő ${i?.displayName} vásárlást, amely a Brave-fiókodhoz van társítva`);
	return /** @type {LocalizedString} */ (`Találtunk egy meglévő ${i?.displayName} előfizetést a Brave fiókjához kapcsolódóan`)
	
};

const nl_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`We hebben een bestaande ${i?.displayName}-aankoop gevonden die is gekoppeld aan je Brave-account`);
	return /** @type {LocalizedString} */ (`We hebben een bestaand ${i?.displayName}-abonnement gevonden dat is gekoppeld aan je Brave-account`)
	
};

const nb_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Vi fant et eksisterende ${i?.displayName}-kjøp tilknyttet din Brave-konto`);
	return /** @type {LocalizedString} */ (`Vi fant et eksisterende ${i?.displayName}-abonnement som er knyttet til Brave-kontoen din`)
	
};

const pl_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Znaleźliśmy istniejący zakup ${i?.displayName} powiązany z Twoim kontem Brave`);
	return /** @type {LocalizedString} */ (`Znaleźliśmy istniejącą subskrypcję ${i?.displayName} powiązaną z Twoim kontem Brave`)
	
};

const pt_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Encontramos uma compra existente do ${i?.displayName} associada à sua conta Brave`);
	return /** @type {LocalizedString} */ (`Identificamos uma assinatura ${i?.displayName} existente associada à sua conta Brave`)
	
};

const ro_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Am găsit o achiziție ${i?.displayName} existentă asociată cu contul tău Brave`);
	return /** @type {LocalizedString} */ (`Am găsit un abonament existent ${i?.displayName} asociat contului tău Brave`)
	
};

const sk_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Našli sme existujúci nákup ${i?.displayName} spojený s vaším účtom Brave`);
	return /** @type {LocalizedString} */ (`Našli sme existujúce predplatné ${i?.displayName} spojené s vaším účtom Brave`)
	
};

const sl_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Našli smo obstoječi nakup ${i?.displayName}, povezan z vašim računom Brave`);
	return /** @type {LocalizedString} */ (`Našli smo obstoječo naročnino »${i?.displayName}«, povezano z vašim računom Brave.`)
	
};

const fi_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Löysimme olemassa olevan ${i?.displayName}-ostoksen, joka on liitetty Brave-tiliisi`);
	return /** @type {LocalizedString} */ (`Löysimme olemassa olevan ${i?.displayName}-tilauksen, joka liittyy Brave-tiliisi`)
	
};

const sv_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Vi hittade ett befintligt ${i?.displayName}-köp kopplat till ditt Brave-konto`);
	return /** @type {LocalizedString} */ (`Vi hittade en befintlig ${i?.displayName}-prenumeration kopplad till ditt Brave-konto`)
	
};

const vi_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Chúng tôi đã tìm thấy một mua hàng ${i?.displayName} hiện có được liên kết với tài khoản Brave của bạn`);
	return /** @type {LocalizedString} */ (`Chúng tôi đã phát hiện một gói đăng ký ${i?.displayName} hiện có liên kết với tài khoản Brave của bạn`)
	
};

const tr_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Brave hesabınızla ilişkili mevcut bir ${i?.displayName} satın alımı bulduk`);
	return /** @type {LocalizedString} */ (`Brave hesabınızla ilişkili mevcut bir ${i?.displayName} aboneliği bulduk`)
	
};

const el_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Βρήκαμε μια υπάρχουσα αγορά ${i?.displayName} συσχετισμένη με τον λογαριασμό σας Brave`);
	return /** @type {LocalizedString} */ (`Βρήκαμε μια υπάρχουσα συνδρομή ${i?.displayName} που σχετίζεται με τον λογαριασμό Brave σας`)
	
};

const bg_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Намерихме съществуваща покупка на ${i?.displayName}, свързана с вашия Brave акаунт`);
	return /** @type {LocalizedString} */ (`Открихме съществуващ абонамент за ${i?.displayName}, свързан с твоя акаунт в Brave`)
	
};

const ru_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Мы нашли уже существующую покупку ${i?.displayName}, связанную с вашим аккаунтом Brave`);
	return /** @type {LocalizedString} */ (`Мы нашли существующую подписку на ${i?.displayName} связанную с вашим аккаунтом Brave`)
	
};

const sr_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Пронашли смо постојећу ${i?.displayName} куповину повезану са вашим Brave account-ом`);
	return /** @type {LocalizedString} */ (`Пронашли смо постојећу претплату на ${i?.displayName} повезану са вашим Brave налогом`)
	
};

const uk_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Ми знайшли наявну покупку ${i?.displayName}, пов'язану з вашим обліковим записом Brave`);
	return /** @type {LocalizedString} */ (`Ми знайшли існуючу підписку ${i?.displayName}, пов'язану з вашим обліковим записом Brave`)
	
};

const ka_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`ჩვენ ვიპოვეთ თქვენს Brave ანგარიშთან დაკავშირებული არსებული ${i?.displayName} შეძენა`);
	return /** @type {LocalizedString} */ (`ვიპოვეთ თქვენს Brave ანგარიშთან დაკავშირებული არსებული ${i?.displayName} გამოწერა`)
	
};

const hi_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`हमें आपके Brave account से जुड़ी एक मौजूदा ${i?.displayName} खरीद मिली`);
	return /** @type {LocalizedString} */ (`हमें आपके ब्रेव अकाउंट से जुड़ा एक मौजूदा ${i?.displayName} सब्सक्रिप्शन मिला है`)
	
};

const th_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`เราพบการซื้อ ${i?.displayName} ที่มีอยู่แล้วซึ่งเชื่อมโยงกับบัญชี Brave ของคุณ`);
	return /** @type {LocalizedString} */ (`เราพบการสมัครสมาชิก ${i?.displayName} ที่มีอยู่ซึ่งเชื่อมโยงกับบัญชี Brave ของคุณ`)
	
};

const ko_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Brave 계정과 연결된 기존 ${i?.displayName} 구매를 찾았습니다`);
	return /** @type {LocalizedString} */ (`Brave 계정과 연결된 기존 ${i?.displayName} 구독을 발견했습니다`)
	
};

const zh_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`我们发现您的 Brave 账户当前正关联着一个 ${i?.displayName} 订阅`)
};

const zh_tw_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`我們發現有一項與您 Brave 帳戶相關聯的現有 ${i?.displayName} 購買`);
	return /** @type {LocalizedString} */ (`我們發現您的 Brave 帳戶已存在與 ${i?.displayName} 相關聯的訂閱服務`)
	
};

const ja_existing_subscription_conflict_heading = /** @type {(inputs: Existing_Subscription_Conflict_HeadingInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`あなたの Brave アカウントに関連付けられた既存の ${i?.displayName} 購入が見つかりました`);
	return /** @type {LocalizedString} */ (`あなたのBrave アカウントに関連付けられている ${i?.displayName} のサブスクリプションが見つかりました`)
	
};

/**
* | product | output |
* | --- | --- |
* | "origin" | "We found an existing {displayName} purchase associated with your Brave account" |
* | * | "We found an existing {displayName} subscription associated with your Brave account" |
*
* @param {Existing_Subscription_Conflict_HeadingInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const existing_subscription_conflict_heading = /** @type {((inputs: Existing_Subscription_Conflict_HeadingInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Existing_Subscription_Conflict_HeadingInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_existing_subscription_conflict_heading(inputs)
	if (locale === "ms") return ms_existing_subscription_conflict_heading(inputs)
	if (locale === "ca") return ca_existing_subscription_conflict_heading(inputs)
	if (locale === "cs") return cs_existing_subscription_conflict_heading(inputs)
	if (locale === "da") return da_existing_subscription_conflict_heading(inputs)
	if (locale === "de") return de_existing_subscription_conflict_heading(inputs)
	if (locale === "et") return et_existing_subscription_conflict_heading(inputs)
	if (locale === "es") return es_existing_subscription_conflict_heading(inputs)
	if (locale === "fr") return fr_existing_subscription_conflict_heading(inputs)
	if (locale === "hr") return hr_existing_subscription_conflict_heading(inputs)
	if (locale === "it") return it_existing_subscription_conflict_heading(inputs)
	if (locale === "lv") return lv_existing_subscription_conflict_heading(inputs)
	if (locale === "lt") return lt_existing_subscription_conflict_heading(inputs)
	if (locale === "hu") return hu_existing_subscription_conflict_heading(inputs)
	if (locale === "nl") return nl_existing_subscription_conflict_heading(inputs)
	if (locale === "nb") return nb_existing_subscription_conflict_heading(inputs)
	if (locale === "pl") return pl_existing_subscription_conflict_heading(inputs)
	if (locale === "pt") return pt_existing_subscription_conflict_heading(inputs)
	if (locale === "ro") return ro_existing_subscription_conflict_heading(inputs)
	if (locale === "sk") return sk_existing_subscription_conflict_heading(inputs)
	if (locale === "sl") return sl_existing_subscription_conflict_heading(inputs)
	if (locale === "fi") return fi_existing_subscription_conflict_heading(inputs)
	if (locale === "sv") return sv_existing_subscription_conflict_heading(inputs)
	if (locale === "vi") return vi_existing_subscription_conflict_heading(inputs)
	if (locale === "tr") return tr_existing_subscription_conflict_heading(inputs)
	if (locale === "el") return el_existing_subscription_conflict_heading(inputs)
	if (locale === "bg") return bg_existing_subscription_conflict_heading(inputs)
	if (locale === "ru") return ru_existing_subscription_conflict_heading(inputs)
	if (locale === "sr") return sr_existing_subscription_conflict_heading(inputs)
	if (locale === "uk") return uk_existing_subscription_conflict_heading(inputs)
	if (locale === "ka") return ka_existing_subscription_conflict_heading(inputs)
	if (locale === "hi") return hi_existing_subscription_conflict_heading(inputs)
	if (locale === "th") return th_existing_subscription_conflict_heading(inputs)
	if (locale === "ko") return ko_existing_subscription_conflict_heading(inputs)
	if (locale === "zh") return zh_existing_subscription_conflict_heading(inputs)
	if (locale === "zh-tw") return zh_tw_existing_subscription_conflict_heading(inputs)
	if (locale === "ja") return ja_existing_subscription_conflict_heading(inputs)
	return en_existing_subscription_conflict_heading(inputs)
});